import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 申請種類のENUM */
enum ApplyCategory {
  /** 契約台帳 */
  laContractLedger = 'LA_CONTRACT_LEDGER',
  /** 物件台帳 */
  laArticleLedger = 'LA_ARTICLE_LEDGER',
}

const nameConfig = {
  laContractLedger: new Map([[Locale.ja, '契約台帳']]),
  laArticleLedger: new Map([[Locale.ja, '物件台帳']]),
};

const toEnum = rawValueToEnum(ApplyCategory, ApplyCategory.laContractLedger);
const toDisplay = enumToName(ApplyCategory, nameConfig);
const toDisplayWithPrefix = enumToName(ApplyCategory, nameConfig, { prefix: true });

export const applyCategory = {
  enum: ApplyCategory,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};

export type { ApplyCategory };
